export default "assets/images/6111b8076a2cf81c73f0e46f41a3af60.png";